// @flow
import './index.less';

import { LoadingOutlined } from '@ant-design/icons';

import { Spin } from 'antd';
import React, { useMemo } from 'react';

type Props = {
  children?: React$Node,
  loading?: boolean,
};

const BasicSpinner = ({ children, loading = false }: Props): React$Node => {
  const indicator = useMemo(() => <LoadingOutlined style={{ fontSize: 24, color: '#eb5757' }} spin />, []);
  return (
    <Spin wrapperClassName="basic-spinner" indicator={indicator} spinning={loading}>
      {children}
    </Spin>
  );
};

export default BasicSpinner;
